if (!customElements.get('occm-image-slider')) {
  class OneColumnContentMixImageSlider extends HTMLElement {
    constructor() {
      super();
      this.swiperRoot = this.querySelector('[data-swiper]');
      this.swiperPagination = this.querySelector('[data-swiper-pagination]');
      this.swiperButtons = this.querySelector('[data-swiper-buttons]');
      this.swiperButtonPrev = this.querySelector('[data-swiper-button-prev]');
      this.swiperButtonNext = this.querySelector('[data-swiper-button-next]');
      this.settings = {
        direction: 'horizontal',
        centerInsufficientSlides: true,
        centeredSlides: true,
        spaceBetween: 24,
        speed: 400,
        loop: true,
        init: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          0: {
            slidesPerView: 1.2,
            navigation: false
          },
          769: {
            slidesPerView: 5,
            navigation: {
              prevEl: this.swiperButtonPrev,
              nextEl: this.swiperButtonNext
            },
            pagination: false
          }
        }
      }
      if (this.getAttribute('data-swiper-settings')) {
        const o = JSON.parse(this.getAttribute('data-swiper-settings'));
        Object.assign(this.settings, o);
      }
      Object.keys(this.settings.breakpoints).forEach(key => {
          key = parseFloat(key);
          if (window.innerWidth > key) {
              this.currentBreakpoint = this.settings.breakpoints[key];
          }
      });
    }
    connectedCallback() {
      this.swiper = new Swiper(this.swiperRoot, this.settings);
      this.swiper.init();
      if (!this.currentBreakpoint.pagination) {
        this.swiperPagination.style.display = 'none';
      } else {
        this.swiperPagination.style.display = 'flex';
      }
      if (!this.currentBreakpoint.navigation) {
        this.swiperButtons.style.display = 'none';
      } else {
        this.swiperButtons.style.display = 'flex';
      }
    }
  }
  customElements.define('occm-image-slider', OneColumnContentMixImageSlider);
}
